import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error no types for this file
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { Flex } from 'foundations-components/components/Flex';
import UILink from 'UIComponents/link/UILink';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import NameCellHoverContent from './NameCellHoverContent';
import { TeamIcon } from '../TeamIcon';
import { StickyCellNameColumn, StickyHoverCellNameColumn } from '../styled/StickyCellNameColumn';
import { getFilters } from '../../selectors/filtersSelectors';
import { getFetchOwnersSucceeded } from '../../selectors/ownersSelectors';
import { setQueryParams } from '../../utils/filters';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NameCell = ({
  isDetailPage,
  onNameCellViewDealsClick,
  onRowClick,
  rowData
}) => {
  const {
    deactivatedUserCount,
    email,
    id,
    isActive,
    isUser,
    name,
    userCount
  } = rowData;
  const isOwnersFetchSucceeded = useSelector(getFetchOwnersSucceeded);
  const filters = useSelector(getFilters);
  const history = useHistory();
  if (isDetailPage) {
    return /*#__PURE__*/_jsx(StickyCellNameColumn, {
      "data-test-id": "detail-view-user-name",
      children: !isOwnersFetchSucceeded ? /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small"
      }) : /*#__PURE__*/_jsx(UIAvatar, {
        hubSpotUserEmail: email,
        children: name
      })
    });
  }
  const showTeamMemberCount = !isUser;
  const handleClick = e => {
    const isCtrlClick = e.ctrlKey || e.metaKey;
    const isShiftClick = e.shiftKey;
    if (!isCtrlClick && !isShiftClick) {
      onNameCellViewDealsClick({
        dealSidebarId: null,
        isTeam: false
      });
    }
    onRowClick(id, isUser, isCtrlClick, isShiftClick);
    setQueryParams({
      history,
      filters,
      setDealGroupingParams: isUser
    });
  };
  const nameLink =
  /*#__PURE__*/
  // TODO: replace with `Button` from foundations-components when the link styling is ready
  // https://git.hubteam.com/HubSpot/forecasting-team/issues/2409
  _jsx(UILink, {
    "data-test-id": "name-cell-name",
    onClick: handleClick,
    children: isUser && !isOwnersFetchSucceeded ? '' : name
  });
  const isDeactivatedUser = isUser && !isActive;
  return /*#__PURE__*/_jsx(StickyHoverCellNameColumn, {
    hoverContent: /*#__PURE__*/_jsx(NameCellHoverContent, {
      onClick: () => {
        onNameCellViewDealsClick({
          dealSidebarId: id,
          isTeam: !isUser
        });
      }
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [isUser ? !isOwnersFetchSucceeded ? /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small"
      }) : /*#__PURE__*/_jsx(UIAvatar, {
        hubSpotUserEmail: email
      }) : /*#__PURE__*/_jsx(TeamIcon, {}), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        marginInlineStart: isUser ? '400' : '200',
        children: [nameLink, isOwnersFetchSucceeded && isDeactivatedUser && /*#__PURE__*/_jsx(Small, {
          "data-test-id": "deactivated-user-subtext",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "repOverviewTable.nameCell.deactivatedUser"
          })
        }), showTeamMemberCount && /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "name-cell-subtext",
            message: deactivatedUserCount ? 'repOverviewTable.cells.teamMemberCountWithDeactivatedUsers' : 'repOverviewTable.cells.teamMemberCount',
            options: {
              count: userCount,
              deactivatedUserCount
            }
          })
        })]
      })]
    })
  });
};
export default NameCell;